
import React from "react";


export default function PopUpAlertModal({openAlert, setOpenAlert,title,clickHandler}) {

  
  
  return (
    <>
  

      {openAlert && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 bg-[#0d0d0c99] "
          aria-modal="true"
          role="dialog"
        >
          <div className="bg-white dark:bg-navy-700 rounded-xl w-full max-w-md mx-4 p-6">
            <h5 className="text-md font-bold text-gray-800 dark:text-white mb-4">
           {title}
            </h5>
         
           
            <div className="flex justify-end space-x-3">
              <button
              onClick={()=>{
                setOpenAlert(false);
              }
                }
                className="px-4 py-1 bg-gray-200 dark:bg-gray-600 rounded hover:bg-gray-300 dark:hover:bg-gray-500"
              >
                No
              </button>
              <button
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                onClick={()=>{
                     clickHandler();
                    setOpenAlert(false);
                   
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
